import useReveal from "@/hooks/useReveal";

const FinalCTASection = () => {
  const [ref, isVisible] = useReveal();

  return (
    <section
      ref={ref}
      data-testid="final-cta-section"
      className="py-20 md:py-32"
      style={{ backgroundColor: "#205B5A" }}
    >
      <div className={`max-w-3xl mx-auto px-6 md:px-12 text-center reveal-section ${isVisible ? "visible" : ""}`}>
        <h2
          data-testid="final-cta-heading"
          className="text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight leading-tight text-white mb-6"
          style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
        >
          Ready to explore LumeroFlow?
        </h2>
        <p
          data-testid="final-cta-body"
          className="text-base md:text-lg text-white/70 leading-relaxed mb-10 max-w-xl mx-auto"
        >
          See how LumeroFlow can help your clinic manage appointments, records, invoicing, and AI-powered documentation in one modern platform.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4 mb-6">
          <a
            href="/app/signup"
            data-testid="final-cta-signup-btn"
            className="bg-white text-[#205B5A] px-8 py-4 rounded-full font-medium text-base hover:bg-white/90 transition-all duration-300 shadow-sm hover:shadow-md inline-flex items-center"
          >
            Sign up now
          </a>
          <a
            href="https://www.lumeroflow.co.uk"
            data-testid="final-cta-demo-btn"
            className="border border-white/30 text-white px-8 py-4 rounded-full font-medium text-base hover:border-white/60 transition-all duration-300 inline-flex items-center"
          >
            Book a demo
          </a>
        </div>
        <a
          href="/app/login"
          data-testid="final-cta-login-link"
          className="text-sm text-white/50 hover:text-white/80 transition-colors duration-200"
        >
          Already have an account? Log in
        </a>
      </div>
    </section>
  );
};

export default FinalCTASection;
